import React, { useEffect } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Divider, Typography } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as mdt from '../../../../common/modaltypes'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import { Item } from '../../../../common/snippets'

const ConfirmModal = ({ title = '', header = "", updateModal, handleConfirm }) => {
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    useEffect(() => {
        focusElemnt('noBtn')
    }, [])
    return (
        <Modal
            headTxt={title}
            width={'35%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}
        >
            <>
                <Box sx={{ padding: '10px 15px' }}>
                    <Typography variant='h6' sx={{ fontWeight: '500', color: "#444", fontSize: '16px', paddingTop: '5px', paddingBottom: '10px' }}>
                        {header}
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'end', padding: '4px 15px' }} className='ReportBtn'>
                    <Item className="disabled-wrapper">
                        <Button variant="outlined" id='noBtn' style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }} className="receiveitembtn"
                            onClick={updateModal}
                            onKeyDown={(e) => {
                                navigation3(e, "yesBtn", 'yesBtn', () => { })
                            }}
                        >
                            NO
                        </Button>
                    </Item>
                    <Item className="disabled-wrapper">
                        <Button variant="outlined" id='yesBtn' style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }} className="receiveitembtn"
                            onClick={handleConfirm}
                            onKeyDown={(e) => {
                                navigation3(e, "noBtn", 'noBtn', () => { })
                            }}
                        >
                            YES
                        </Button>
                    </Item>
                </Box>
            </>

        </Modal>
    )
}

export default ConfirmModal